import { connect, mapStateToProps } from '../../../../helpers/Common'

const PersonnelCVAdditionalInformation = ({ redux, val }) => {
  const data = val ? val.split('\n') : []
  return (
    <div className='card rounded p-3 mb-0' style={{ maxHeight: 160, overflow: 'auto' }}>
      {data?.map((desc, idx) => (
        <p className='mb-0' key={`desc-${idx}`}>{desc} <br /></p>
      ))}
    </div>
  )
}

export default connect(mapStateToProps)(PersonnelCVAdditionalInformation)
